module.exports = __webpack_public_path__ + "static/media/tips-and-resources.46443441.svg";